import { createAction, props } from '@ngrx/store';
import { UsersListFeatureState, UsersListGridData } from './users-list.models';

const snapshotPersisted = createAction(
  '[Users List] Snapshot persisted',
  props<{ snapshot: Omit<UsersListFeatureState, 'gridData'> }>()
);

const gridDataCached = createAction(
  '[Users List] Grid data cached',
  props<{ gridData: UsersListGridData }>()
);

const gridDataCleared = createAction('[Users List] Grid data cleared');

const cleared = createAction('[Users List] Cleared');

export const UsersListActions = {
  snapshotPersisted,
  gridDataCached,
  gridDataCleared,
  cleared
};
